"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_1 = require("@/client/directives/i18n");
exports.default = {
    install: (app) => {
        app.config.globalProperties.$t = i18n_1.$t;
        app.directive('i18n', {
            mounted: (el, binding) => {
                el.setAttribute('tm-has-i18n', 'true');
                (0, i18n_1.translateTextNode)(el, binding);
            },
            updated: i18n_1.translateTextNode,
        });
    },
};
